/**
 * 낭만월운 표지 패널 — 월별 헤더/본문 카피.
 * key: 양력 월 (1-12)
 * - headline: 컬러 헤딩 ("5월, 검은 뱀의 달")
 * - paragraphs: 본문 문단 배열 (HTML 문자열, v-html로 바인딩)
 *   - 강조: <strong class="mf-cover-copy__strong">간지월명</strong>
 *   - 절기: <em class="mf-cover-copy__accent">입하(立夏)</em>
 */
export const MONTHLY_COVER_COPY = {
  5: {
    headline: '5월, 검은 뱀의 달',
    paragraphs: [
      '밤의 빗물 같은 계수(癸)가 하늘에서 내리고,<br />불씨를 품은 뱀(巳)이 조용히 움직이기 시작하는 <strong class="mf-cover-copy__strong">계사월</strong>',
      '짙은 초록으로 바뀌어 가는 <em class="mf-cover-copy__accent">입하(立夏)</em>,<br />조금씩 모든 것이 차오르는 <em class="mf-cover-copy__accent">소만(小滿)</em>.',
      '싱그러운 계절의 문턱에서, 마음도 천천히 새로운 방향으로 흐르기 시작해요.',
      '이달의 기운이 당신에게 어떤 이야기가 될까요?<br />낭만만세력이 함께 짚어드릴게요.',
    ],
  },
  6: {
    headline: '6월, 푸른 말의 달',
    paragraphs: [
      '곧게 뻗어 올라가는 갑목(甲)의 나무처럼,<br />멈추지 않고 달려 나가는 말(午)의 힘이 깃든 <strong class="mf-cover-copy__strong">갑오월</strong>',
      '가장 바쁜 절기 <em class="mf-cover-copy__accent">망종(芒種)</em>,<br />그리고 해가 가장 길어지는 <em class="mf-cover-copy__accent">하지(夏至)</em>.',
      '뿌릴 건 뿌리고, 움직일 건 움직이며 하루의 에너지가 가장 길게 이어지는 달이에요.',
      '이달의 흐름 속에서, 당신의 목표도 조금 더 선명해질지 몰라요.',
    ],
  },
  7: {
    headline: '7월, 초록 양의 달',
    paragraphs: [
      '곧게 뻗기보다 천천히 감아 올라가는 을목(乙),<br />부드럽지만 은근한 고집을 품은 양(未)의 <strong class="mf-cover-copy__strong">을미월</strong>',
      '작은 더위 <em class="mf-cover-copy__accent">소서(小暑)</em>가 장마를 데려오고,<br />큰 더위 <em class="mf-cover-copy__accent">대서(大暑)</em>가 한여름의 문을 활짝 엽니다.',
      '뜨거운 계절 속에서도 내 속도와 방향을 다시 돌아보게 되는 달이에요.',
      '조금 느리더라도 괜찮아요.<br />이달은 당신만의 리듬을 찾아가는 시간이니까요.',
    ],
  },
  8: {
    headline: '8월, 빛나는 원숭이의 달',
    paragraphs: [
      '태양처럼 뜨거운 병화(丙)가 하늘을 비추고,<br />영리한 원숭이(申)가 재빠르게 움직이는 <strong class="mf-cover-copy__strong">병신월</strong>.',
      '가을이 시작되는 <em class="mf-cover-copy__accent">입추(立秋)</em>,<br />그리고 더위가 한풀 꺾이는 <em class="mf-cover-copy__accent">처서(處暑)</em>.',
      '한여름의 끝자락에서 계절의 방향이 천천히 바뀌기 시작하는 달이에요.',
      '뜨거움 속에서도 마음은 조금 선명해지고,<br />새로운 흐름을 준비할 시간이 찾아옵니다.',
    ],
  },
};

export const getMonthlyCoverCopy = (month) => MONTHLY_COVER_COPY[Number(month)] || null;
